import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    lock: () => {
      const noLock = Promise.resolve(() => {});
      if (typeof navigator === "undefined" || !navigator.locks) return noLock;
      return new Promise<() => void>((resolve) => {
        const timer = setTimeout(() => resolve(() => {}), 10000);
        navigator.locks
          .request("supabase_auth_lock", { mode: "exclusive" }, () =>
            new Promise<void>((release) => {
              clearTimeout(timer);
              resolve(release);
            })
          )
          .catch(() => {
            clearTimeout(timer);
            resolve(() => {});
          });
      });
    },
  },
});